import React from "react";
import { ButtonCta } from "@/components";
import Image from "next/image";
import { fontSizes } from "@/constants/constants";
import { OpenBookLine } from "./decor";

const GenreCards = ({ title, description, categories }) => {
  return (
    <section className="relative overflow-hidden bg-paper bg-paper-grain py-20 px-4 md:px-8">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-14">
        {/* Left — sticky intro */}
        <div className="lg:col-span-4 lg:sticky lg:top-28 lg:h-fit" data-aos="fade-right">
          <span className="eyebrow flex items-center gap-3 text-gold-deep">
            <span className="h-px w-8 bg-gold/70" />
            Genre Expertise
          </span>
          <h2 className={`mt-5 font-display font-semibold leading-tight text-ink ${fontSizes.text_4_xl}`}>
            {title}
          </h2>
          <p className={`mt-5 leading-relaxed text-ink-soft ${fontSizes.large}`}>
            {description}
          </p>

          <div className="mt-8 flex justify-start">
            <OpenBookLine className="h-28 w-40 text-brand-600" />
          </div>

          <div className="mt-8">
            <ButtonCta buttonText={"Request A Quote"} classStyle="text-white bg-brand-600 hover:bg-brand-700 h-12" />
          </div>
        </div>

        {/* Right — genre cards */}
        <div className="lg:col-span-8">
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
            {categories.map((category, i) => (
              <div
                key={category.id}
                data-aos="fade-up"
                data-aos-delay={(i % 2) * 90}
                className="group relative overflow-hidden rounded-2xl border border-ink/10 bg-white p-6 transition-all duration-400 hover:-translate-y-1.5 hover:border-gold/40 hover:shadow-editorial"
              >
                {/* top accent line */}
                <span className="absolute inset-x-0 top-0 h-1 origin-left scale-x-0 bg-gradient-to-r from-brand-500 to-gold transition-transform duration-500 group-hover:scale-x-100" />
                <div className="flex items-start gap-4">
                  <div className="flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-2xl bg-brand-50 transition-transform duration-300 group-hover:scale-105">
                    <Image src={category.icon} alt={category.title} className="h-11 w-11 object-contain" />
                  </div>
                  <div className="min-w-0">
                    <h3 className={`font-display font-semibold text-ink ${fontSizes.text_xl}`}>
                      {category.title}
                    </h3>
                    <p className={`mt-1.5 leading-relaxed text-ink-soft ${fontSizes.m}`}>
                      {category.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default GenreCards;
